module.exports = __webpack_public_path__ + "img/11.4789d420.jpg";